import React, { useState, useRef, useEffect } from "react"
import { Upload, X, Check, AlertCircle, Loader2, Trash2, Save, AlertTriangle } from "lucide-react"
import { Button, Badge, Input, message, Typography, useCRUDController, Row, Col, Select ,Spin} from "../../ui/ot"
import { GroupColumnChart } from "../../ui/ot"
import dayjs from 'dayjs';

const colors = ["#fb7d89", "#bad1c9", "#85b873", "#e5db9e", "#f3a46c", "#f6bb5d", "#55abb8"]
const basicFilterSetting = ["branchcode", "time"]

const ChartCategoryBorrowStatistics = ({
    filterSearchParams = [...basicFilterSetting],
    propsDataParams = null,
}) => {
    const [data, setData] = useState([
    ])
    const [chartConfig, setChartConfig] = useState({
        visitors: {
            label: "Visitors",
        }
    })
    const [searchParams, setSearchParams] = useState({
        branchcode: null,
        start_time: filterSearchParams.includes("time") ? dayjs().startOf('year').format('YYYY-MM-DD') : null,
        end_time: filterSearchParams.includes("time") ? dayjs().endOf('year').format('YYYY-MM-DD') : null,
        ...propsDataParams
    })

    const [loading, setLoading] = useState(false)
    function transformToNumeric(data) {
        return data.map(item => {
            const newItem = { 
                description: item?.description ,
                itype:item?.itype
            };
            for (const key in item) {
                if (key !== 'description' && key !== 'itype') {
                    newItem[key] = Number(item[key]);
                }
            }
            return newItem;
        });
    }
    const dataController = useCRUDController({ apiRoute: "/koha/report/circulation/item_type/checkout_and_return" })
    const getData = () => {
        setLoading(true)
        dataController.getData({
            ...searchParams
        }).then((response) => {
            setLoading(false)
            if (response?.data) {
                let newData = response?.data
                const labelSet = {
                    borrow_count:"借閱數量",
                    return_count:"歸還數量",
                }
                newData =transformToNumeric(newData)
                setChartConfig((pre) => {
                    const config = {}; // 建立一個空物件
                    let firstData = newData?.find((e) => true) || {}
                    Object.keys(firstData).forEach((key, index) => {
                        if (key !== 'description' && key !== 'itype') {
                            config[key] = {
                                label: labelSet[key],
                                color: colors[index % colors.length],
                            };
                        }
                    });
                    return config;
                })
                setData(newData)
            }
        })
    }
    const libraryController = useCRUDController({ apiRoute: "/koha/library" })

    useEffect(() => {
        getData()
    }, [searchParams])

    useEffect(() => {
        libraryController.getData({})
    }, [])
    return (<Row >
        <Col span={24}>
            <Row gutter={[4, 4]}>
                {filterSearchParams.includes("time") ? <Col  >
                    <Row gutter={[4, 4]} align={"middle"}>
                        <Col>
                            <Typography.P>
                                日期區間:
                            </Typography.P>
                        </Col>
                        <Col>
                            <Input
                                placeholder={"起"}
                                type="date"
                                value={searchParams?.start_time ? searchParams?.start_time : ""}
                                onChange={(e) => {
                                    setSearchParams((pre) => {
                                        if (dayjs(e.target.value).isBefore(dayjs(pre?.end_time, "YYYY-MM-DD"))) {
                                            return {
                                                ...pre,
                                                start_time: dayjs(e.target.value).format("YYYY-MM-DD"),
                                            }
                                        }
                                        else {
                                            return {
                                                ...pre,
                                                start_time: pre?.end_time,
                                                end_time: e.target.value,
                                            }
                                        }

                                    })
                                }}
                            />
                        </Col>
                        <Col>
                            <Typography.Title level={4}>
                                ~
                            </Typography.Title>
                        </Col>
                        <Col>
                            <Input
                                placeholder={"訖"}
                                type="date"
                                value={searchParams?.end_time ? searchParams?.end_time : ""}
                                onChange={(e) => {
                                    setSearchParams((pre) => {
                                        if ((dayjs(e.target.value)).isBefore(pre?.start_time)) {
                                            return {
                                                ...pre,
                                                start_time: e.target.value,
                                                end_time: pre?.start_time,
                                            }
                                        }
                                        else {
                                            return {
                                                ...pre,
                                                end_time: e.target.value,
                                            }
                                        }

                                    })
                                }}
                            />
                        </Col>
                        {(searchParams.start_time || searchParams.end_time) &&
                            <Col>
                                <Button
                                    type={"icon"}
                                    onClick={() => {
                                        setSearchParams((pre) => {
                                            return {
                                                ...pre,
                                                start_time: undefined,
                                                end_time: undefined
                                            }
                                        })
                                    }}>
                                    X
                                </Button>
                            </Col>
                        }
                    </Row>
                </Col> : <></>}
                {filterSearchParams.includes("branchcode") ? <Col>
                    <Row align={"middle"} gutter={[8, 8]}>
                        <Col>
                            分館篩選：
                        </Col>
                        <Col>
                            <Select
                                allowClear={true}
                                defaultValue={searchParams?.branchcode}
                                value={searchParams?.branchcode}
                                onChange={(value) => {
                                    setSearchParams((pre) => {
                                        return {
                                            ...pre,
                                            branchcode: value
                                        }
                                    })
                                }}
                                options={libraryController?.ResponseData?.map((option) => {
                                    return {
                                        label: `(${option?.branchcode})${option?.branchname}`,
                                        value: option?.branchcode,
                                    }
                                })}
                            >
                            </Select>
                        </Col>
                    </Row>
                </Col> : <></>}
            </Row>
        </Col>
        <Col span={24}>
             {loading ? <Col span={24}>
            <Row justify="center">
                <Col>
                    <Spin />
                </Col>
            </Row>
        </Col>
            :
            <Col span={24}>
                {data.length === 0 ?
                    <Row justify="center">
                        <Col>
                            無資料 
                        </Col>
                    </Row>
                    :
                    <GroupColumnChart
                        //數值類型的key
                        chartConfig={chartConfig}
                        //data
                        chartData={data}
                        //X 軸顯示的名稱的key
                        xDataKeyArr={["description"]}
                        //Y 軸顯示的名稱得key
                        yDataKeyArr={Object.keys(chartConfig)} //幾條線
                        //要不要顯示標籤在頂部
                        showLabel={true}
                    />
                }
            </Col>}
        </Col>
    </Row >)
}
export { ChartCategoryBorrowStatistics }